export default __webpack_public_path__ + "static/2040-3-94e07208e833a03a50b5c709e8fcac3a.jpg";